import React, { forwardRef } from 'react';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { cn } from '../../utils';

export interface IconProps extends FontAwesomeIconProps {
  icon: IconDefinition;
}

const Icon = forwardRef<SVGSVGElement, IconProps>(
  // eslint-disable-next-line react/prop-types
  ({ className, ...props }, ref) => {
    return (
      <FontAwesomeIcon
        className={cn('text-current', className)}
        ref={ref}
        {...props}
      />
    );
  }
);
Icon.displayName = 'Icon';

export { Icon };
